/**
 * Utility functions for analytics components
 */

/**
 * Safely converts a value to a number
 * @param {*} value - The value to convert
 * @param {number} defaultValue - Default value if conversion fails
 * @returns {number}
 */
export const safeParseFloat = (value, defaultValue = 0) => {
  if (value === null || value === undefined) return defaultValue;
  const parsed = parseFloat(value);
  return isNaN(parsed) ? defaultValue : parsed;
};

/**
 * Safely converts a value to an integer
 * @param {*} value - The value to convert
 * @param {number} defaultValue - Default value if conversion fails
 * @returns {number}
 */
export const safeParseInt = (value, defaultValue = 0) => {
  if (value === null || value === undefined) return defaultValue;
  const parsed = parseInt(value, 10);
  return isNaN(parsed) ? defaultValue : parsed;
};

/**
 * Formats a number to fixed decimal places with fallback
 * @param {*} value - The value to format
 * @param {number} decimals - Number of decimal places
 * @param {string} fallback - Fallback string if value is invalid
 * @returns {string}
 */
export const safeToFixed = (value, decimals = 1, fallback = '0.0') => {
  const num = safeParseFloat(value);
  return num.toFixed(decimals);
};

/**
 * Safely accesses a nested object property
 * @param {object} obj - The object to access
 * @param {string} path - Dot-separated path to the property
 * @param {*} defaultValue - Default value if property doesn't exist
 * @returns {*}
 */
export const safeGet = (obj, path, defaultValue = null) => {
  if (!obj || typeof obj !== 'object') return defaultValue;
  
  const keys = path.split('.');
  let result = obj;
  
  for (const key of keys) {
    if (result === null || result === undefined) return defaultValue;
    result = result[key];
  }
  
  return result !== undefined ? result : defaultValue;
};

